import axios from 'axios';
import { getItem } from '../utils';

// const domain = window.location.href.split('/');
// const subdomain = domain[2].split('.')[0];

// const baseURL =
//   subdomain === 'atlas'
//     ? 'https://atlas.prd.api.p4adm.com/'
//     : 'https://atlas.prd.externals-atlas.com';

const fullAtlas = axios.create({
  baseURL: 'https://atlas.prd.api.p4adm.com',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

fullAtlas.interceptors.request.use(
  async (request) => {
    const PROJECT = await getItem('tk-project');
    const USER = await getItem('tk-user');
    const COMPANY = await getItem('companyId');
    request.headers['tk-project'] = PROJECT;

    if (PROJECT && USER) {
      request.headers['tk-project'] = PROJECT;
      request.headers['tk-user'] = USER;
    }

    // if (
    //   (PROJECT &&
    //     [
    //       '/oauth/users/',
    //       '/password/recovery',
    //       '/password/change',
    //       '/onboarding/account/create',
    //       '/uploads/documents/accounts',
    //     ].includes(request.url)) ||
    //   request.url.substr(0, 13) === '/users/email/' ||
    //   request.url.substr(0, 13) === '/users/taxId/' ||
    //   request.url.substr(0, 13) === '/users/phone/' ||
    //   request.url.substr(0, 12) === '/product-dns' ||
    //   request.url.substr(0, 12) === '/product-dns' ||
    //   request.url.substr(0, 20) === '/twofactors/request/' ||
    //   request.url.substr(0, 21) === '/twofactors/validate/'
    // ) {
    //   request.headers['tk-project'] = PROJECT;
    // }

    request.headers['companyId'] = COMPANY ? COMPANY : '';

    return request;
  },
  function (error) {
    return Promise.reject(error);
  }
);

fullAtlas.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 403) {
      const user = getItem('userId');

      if (user) {
        setTimeout(() => window.dispatchEvent(new Event('relogin')), 250);
      }
    }
    return Promise.reject(error);
  }
);

export default fullAtlas;
